import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { calculateRem } from '@uie/javascript-style-helpers';
import Icon from '@vds/icons';
import { colors } from '@vds-core/theme';
var propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  height: PropTypes.number,
  selected: PropTypes.bool,
  width: PropTypes.number,
  //DEPRECATED
  checked: PropTypes.bool
};
var defaultProps = {
  disabled: false,
  error: false,
  height: 20,
  width: 20
};
var CHECK_SIZE = 20;

var getValidationState = function getValidationState(_ref) {
  var disabled = _ref.disabled,
      error = _ref.error;

  if (disabled) {
    return colors.coolGray3;
  }

  if (error) {
    return colors.orange;
  }

  return colors.black;
};

var sharedHitAreaStyles = /*#__PURE__*/css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  left: ", ";\n  position: absolute;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  top: 50%;\n"])), calculateRem(10));
var HitArea = /*#__PURE__*/styled.div.withConfig({
  displayName: "HitArea",
  componentId: "sc-1w1qhos-0"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  cursor: ", ";\n  display: inline-block;\n  height: ", ";\n  width: ", ";\n  ", ";\n"])), sharedHitAreaStyles, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? 'default' : 'pointer';
}, calculateRem(44), calculateRem(44), function (_ref3) {
  var error = _ref3.error,
      disabled = _ref3.disabled;
  return !error && !disabled && "\n    &:hover + span {\n        box-shadow: 0 0 0 ".concat(calculateRem(1), " ").concat(colors.black, ";\n      \n    }\n ");
});
var StyledWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledWrapper",
  componentId: "sc-1w1qhos-1"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: inline-block;\n  content: '';\n  height: ", ";\n  left: 50%;\n  position: relative;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: ", ";\n"])), calculateRem(CHECK_SIZE), calculateRem(CHECK_SIZE));
var StyledInner = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledInner",
  componentId: "sc-1w1qhos-2"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  left: 50%;\n  box-sizing: border-box;\n  width: ", ";\n  height: ", ";\n  transform: translate(-50%, -50%);\n  background-color: ", ";\n  border-style: solid;\n  border-color: ", ";\n  border-width: ", ";\n  box-shadow: ", ";\n  ", ";\n"])), calculateRem(CHECK_SIZE), calculateRem(CHECK_SIZE), function (props) {
  return props.disabled && props.selected ? colors.coolGray3 : props.selected ? colors.black : "transparent";
}, function (props) {
  return getValidationState(props);
}, function (_ref4) {
  var error = _ref4.error,
      disabled = _ref4.disabled;
  return error && !disabled ? calculateRem(2) : calculateRem(1);
}, function (_ref5) {
  var hovered = _ref5.hovered,
      error = _ref5.error,
      disabled = _ref5.disabled;
  return hovered && !error && !disabled ? "0 0 0 ".concat(calculateRem(1), " ").concat(colors.black) : error && !disabled ? "0 0 0 ".concat(calculateRem(1), " ").concat(colors.orange) : "none";
}, function (_ref6) {
  var error = _ref6.error,
      disabled = _ref6.disabled;
  return !error && !disabled && "\n    &:hover {\n        box-shadow: 0 0 0 ".concat(calculateRem(1), " ").concat(colors.black, ";\n      \n    }\n ");
});
/**
 * @ignore
 */

var CheckboxIcon = function CheckboxIcon(props) {
  var selected = props.checked || props.selected || false;
  return /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement(HitArea, {
    error: props.error,
    disabled: props.disabled
  }), /*#__PURE__*/React.createElement(StyledInner, _extends({}, props, {
    hovered: props.hovered,
    error: props.error,
    disabled: props.disabled,
    className: "styledInner"
  }), selected && /*#__PURE__*/React.createElement(Icon, {
    ariaHidden: true,
    color: "white",
    name: "checkmark",
    size: "extraSmall",
    medium: true,
    tabIndex: -1
  })));
};

CheckboxIcon.defaultProps = defaultProps;
CheckboxIcon.propTypes = propTypes;
export default CheckboxIcon;